export const AI_FEATURES = {
  moduleKey: 'ai-assistant',
  features: ['ai.scenario.generate', 'ai.chat', 'ai.shift-copilot'] as const,
  featureMeta: {
    'ai.scenario.generate': {
      name: 'Generate AI scenarios',
      translations: {
        name: { de: 'KI-Szenarien generieren', en: 'Generate AI scenarios', fr: 'Générer des scénarios IA', it: 'Generare scenari IA' },
      },
    },
    'ai.chat': {
      name: 'AI chat',
      translations: { name: { de: 'KI-Chat', en: 'AI chat', fr: 'Chat IA', it: 'Chat IA' } },
    },
    'ai.shift-copilot': {
      name: 'AI shift copilot',
      translations: {
        name: { de: 'KI-Schicht-Copilot', en: 'AI shift copilot', fr: 'Copilote IA pour les shifts', it: 'Copilota IA per i turni' },
      },
    },
  },
} as const;
